module.exports = __webpack_public_path__ + "img/full7-min.1ef68074.png";